import { ADMIN, AUTHEN } from "../apiConstant";
import BaseApi from "../baseApi";

class AuthApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  login(body) {
    return this.post(AUTHEN + "/login", body);
  }

  register(body) {
    return this.post(AUTHEN + "/register", body);
  }

  getMe(token) {
    return this.post(
      `${ADMIN}/me`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token, //the token is a variable which holds the token
        },
      }
    );
  }

  getAccessToken(body) {
    return this.post(`${AUTHEN}/access-token`, body);
  }

  logout() {
    return this.post(`${AUTHEN}/logout`, {});
  }

  changePassword(body) {
    return this.post(AUTHEN + "/change-password", body);
  }
}

export default AuthApi;
